<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Shared Print Element Service"
    seFeDataSubtitle="Print any rendered element in a clean, full-page app layout and add component-specific print polish with a print class.">
  </se-fe-header>

  <div seFePageContent>
    <se-fe-card>
      <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
      <se-fe-card-content>
        <p>
          Use <code>PrintElementService</code> when you want to print a single rendered section of the page
          instead of the whole application shell.
        </p>
        <p>
          The shared service handles print isolation and full-page framing. Components can optionally pass a
          <code>printClassName</code> to hide actions, remove borders, or swap interactive content for a print-friendly version.
        </p>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="Usage"></se-fe-card-header>
      <se-fe-card-content>
        <se-fe-docs-code [code]="usageTs" lang="ts"></se-fe-docs-code>
        <se-fe-docs-code [code]="usageHtml" lang="html"></se-fe-docs-code>
        <se-fe-docs-code [code]="usageScss" lang="scss"></se-fe-docs-code>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="Example: Profile Bar"></se-fe-card-header>
      <se-fe-card-content>
        <p>Simple shared UI component example using <code>se-po-profile-bar</code>.</p>
        <se-fe-button seFeDataType="button" (click)="printProfileBar()">Print Profile Bar Example</se-fe-button>
        <div #profileBarExample class="print-element-service-docs__print-root print-element-service-docs__example-shell">
          <se-fe-card>
            <se-fe-card-content>
              <div class="print-element-service-docs__eyebrow">Profile Bar</div>
              <div class="print-element-service-docs__header">
                <se-po-profile-bar [selfPersona]="selfPersona"></se-po-profile-bar>
                <div class="print-element-service-docs__actions">
                  <se-fe-button seFeDataType="button" [seFeDataSmall]="true">Edit</se-fe-button>
                </div>
              </div>
            </se-fe-card-content>
          </se-fe-card>
        </div>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="Example: Persona Avatar"></se-fe-card-header>
      <se-fe-card-content>
        <p>Simple shared UI component example using <code>se-po-persona-avatar</code>.</p>
        <se-fe-button seFeDataType="button" (click)="printPersonaAvatar()">Print Persona Avatar Example</se-fe-button>
        <div #personaAvatarExample class="print-element-service-docs__print-root print-element-service-docs__example-shell">
          <se-fe-card>
            <se-fe-card-content>
              <div class="print-element-service-docs__header print-element-service-docs__header--stacked">
                <div class="print-element-service-docs__eyebrow">Persona Avatar</div>
                <h2 class="print-element-service-docs__title">Profile Summary</h2>
              </div>
              <se-po-persona-avatar
                [persona]="avatarPersona"
                headerDataSize="700"
                [showGraduation]="true">
              </se-po-persona-avatar>
            </se-fe-card-content>
          </se-fe-card>
        </div>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="Example: Highlight Labels"></se-fe-card-header>
      <se-fe-card-content>
        <p>Simple shared UI component example using <code>se-po-highlight-label</code>.</p>
        <se-fe-button seFeDataType="button" (click)="printHighlightLabels()">Print Highlight Label Example</se-fe-button>
        <div #highlightLabelExample class="print-element-service-docs__print-root print-element-service-docs__example-shell">
          <se-fe-card>
            <se-fe-card-content>
              <div class="print-element-service-docs__eyebrow">Highlight Label</div>
              <h2 class="print-element-service-docs__title">Label Variants</h2>
              <div class="print-element-service-docs__label-stack">
                <div>
                  <se-po-highlight-label
                    label="This is a label for My Child"
                    theme="child">
                  </se-po-highlight-label>
                </div>
                <div>
                  <se-po-highlight-label
                    label="This is a label for Myself or another adult"
                    theme="adult">
                  </se-po-highlight-label>
                </div>
              </div>
            </se-fe-card-content>
          </se-fe-card>
        </div>
      </se-fe-card-content>
    </se-fe-card>
  </div>
</se-fe-page>
